import { render, staticRenderFns } from "./WizardContentMediaIndicator.vue?vue&type=template&id=1136fc4b&scoped=true&"
import script from "./WizardContentMediaIndicator.vue?vue&type=script&lang=ts&"
export * from "./WizardContentMediaIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentMediaIndicator.vue?vue&type=style&index=0&id=1136fc4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1136fc4b",
  null
  
)

export default component.exports